import { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  FolderKanban,
  UsersRound,
  Wallet,
  Package,
  ShieldCheck,
  Users,
  Menu,
  X,
  ChevronRight,
  Building2,
} from "lucide-react";

import "./AdminSidebar.css";

const menuItems = [
  {
    label: "Dashboard",
    path: "/admin-dashboard",
    icon: LayoutDashboard,
    end: true,
  },
  {
    label: "Projects",
    path: "/projects",
    icon: FolderKanban,
  },
  {
    label: "Leads",
    path: "/leads",
    icon: UsersRound,
  },
  {
    label: "Payments",
    path: "/payments",
    icon: Wallet,
  },
  {
    label: "Items Master",
    path: "/admin-master-items",
    icon: Package,
  },
  {
    label: "Roles",
    path: "/roles",
    icon: ShieldCheck,
  },
  {
    label: "Users",
    path: "/users",
    icon: Users,
  },
];

export default function AdminSidebar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeSidebar = () => {
    setMobileOpen(false);
  };

  return (
    <>
      {/* MOBILE MENU BUTTON */}

      <button
        type="button"
        className="admin-sidebar-mobile-toggle"
        onClick={() => setMobileOpen((prev) => !prev)}
        aria-label={mobileOpen ? "Close sidebar" : "Open sidebar"}
        aria-expanded={mobileOpen}
        aria-controls="admin-main-sidebar"
      >
        {mobileOpen ? <X size={21} /> : <Menu size={21} />}
      </button>

      {/* MOBILE OVERLAY */}

      {mobileOpen && (
        <button
          type="button"
          className="admin-sidebar-overlay"
          onClick={closeSidebar}
          aria-label="Close sidebar"
        />
      )}

      {/* SIDEBAR */}

      <aside
        id="admin-main-sidebar"
        className={`admin-sidebar ${mobileOpen ? "admin-sidebar-open" : ""}`}
      >
        {/* BRAND */}

        <div className="admin-sidebar-brand">
          <div className="admin-sidebar-brand-icon">
            <Building2 size={24} strokeWidth={2} />
          </div>

          <div className="admin-sidebar-brand-text">
            <strong>SOFTVOLUTE BUILDCON LLP</strong>
          </div>
        </div>

        {/* WORKSPACE */}

        <div className="admin-sidebar-workspace">
          <span className="admin-sidebar-workspace-dot" />

          <div>
            <strong>Admin Workspace</strong>
            <small>Management Console</small>
          </div>
        </div>

        {/* NAVIGATION */}

        <div className="admin-sidebar-navigation">
          <div className="admin-sidebar-section-title">MAIN MENU</div>

          <nav className="sidebar-menu" aria-label="Admin navigation">
            {menuItems.map((item) => {
              const Icon = item.icon;

              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.end}
                  onClick={closeSidebar}
                  className={({ isActive }) =>
                    `admin-sidebar-link ${isActive ? "active" : ""}`
                  }
                >
                  <span className="admin-sidebar-link-icon">
                    <Icon size={19} strokeWidth={1.9} />
                  </span>

                  <span className="admin-sidebar-link-label">{item.label}</span>

                  <ChevronRight
                    size={15}
                    className="admin-sidebar-link-arrow"
                  />
                </NavLink>
              );
            })}
          </nav>
        </div>

        {/* FOOTER */}

        <div className="admin-sidebar-footer">
          <div className="admin-sidebar-footer-icon">S</div>

          <div className="admin-sidebar-footer-text">
            <strong>SVB System</strong>
            <span>Admin Panel</span>
          </div>

          <span className="admin-sidebar-online-dot" />
        </div>
      </aside>
    </>
  );
}
